import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule, Optional, SkipSelf } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i2 from '@upr-web-primer/locale';
import { of } from 'rxjs';
const VenueUrls = {
  GET_VENUE_BY_ID: '/Venues/{venueId}',
  GET_VENUE_HOURS_BY_ID: '/Venues/{venueId}/Hours'
};
const BlockoutUrls = {
  GET_PASS_TYPES: '/PassTypes',
  GET_BLOCKOUT_DATES: '/BlockoutDatesGds/{passId}'
};
class UprMobileService {
  constructor(httpClient, localeService, uprMobileServiceConfig) {
    this.httpClient = httpClient;
    this.localeService = localeService;
    this.uprMobileServiceConfig = uprMobileServiceConfig;
  }
  fetchData(url, params) {
    if (!url) {
      return of('URL is not present!!');
    }
    const isApiWithLocaleIssue = url.includes('PointsOfInterest/Shows') || url.includes('ShowsAndAttractions');
    return this.httpClient.get(this.getUrl(this.uprMobileServiceConfig.baseUrl, url), {
      headers: this.getHeaders(isApiWithLocaleIssue),
      params: params
    });
  }
  fetchVenueHoursById(venueId, endDate, params) {
    const path = this.replaceVenueId(VenueUrls.GET_VENUE_HOURS_BY_ID, venueId);
    const query = endDate ? `?endDate=${endDate}` : '';
    return this.fetchData(path + query, params);
  }
  fetchBlockoutDatesById(passId, endDate, params) {
    const path = BlockoutUrls.GET_BLOCKOUT_DATES.replace('{passId}', passId);
    const query = `?endDate=${endDate}&api-version=1.0`;
    return this.fetchData(path + query, params);
  }
  post(url, body) {
    return this.httpClient.post(this.uprMobileServiceConfig.baseUrl + url, body, {
      headers: this.getHeaders()
    });
  }
  getHeaders(isApiWithLocaleIssue = false) {
    const locale = this.localeService.getFromStorage();
    const language = locale.language;
    const country = isApiWithLocaleIssue && locale.country === 'cn' ? locale.country.toUpperCase() : locale.country;
    const httpOptions = new HttpHeaders({
      'X-UNIWebService-ApiKey': this.uprMobileServiceConfig.key,
      'X-UNIWebService-Token': this.uprMobileServiceConfig.token,
      'Accept-Language': `${language}-${country}`
    });
    return httpOptions;
  }
  /**
   * @private method to replace the venue id in the url
   * @memberof UprMobileService
   * @param url
   * @returns string by replacing {venueId}
   **/
  replaceVenueId(url, venueId) {
    return url ? url.replace('{venueId}', venueId) : '';
  }
  getUrl(url, path) {
    const urlEndsWithSlash = url[url.length - 1] === '/';
    const pathStartsWithSlash = path.startsWith('/');
    if (urlEndsWithSlash && pathStartsWithSlash) {
      return url + path.substring(1);
    } else if (!urlEndsWithSlash && !pathStartsWithSlash) {
      return url + '/' + path;
    }
    return url + path;
  }
  static {
    this.ɵfac = function UprMobileService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UprMobileService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LocaleService), i0.ɵɵinject('UprMobileServiceConfig'));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UprMobileService,
      factory: UprMobileService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UprMobileService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }, {
    type: i2.LocaleService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['UprMobileServiceConfig']
    }]
  }], null);
})();
class UprMobileServiceModule {
  constructor(parentModule) {
    if (parentModule) {
      throw new Error('GreetingModule is already loaded. Import it in the AppModule only');
    }
  }
  static forRoot(config) {
    return {
      ngModule: UprMobileServiceModule,
      providers: [{
        provide: 'UprMobileServiceConfig',
        useValue: config
      }, UprMobileService]
    };
  }
  static {
    this.ɵfac = function UprMobileServiceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UprMobileServiceModule)(i0.ɵɵinject(UprMobileServiceModule, 12));
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UprMobileServiceModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UprMobileServiceModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule]
    }]
  }], () => [{
    type: UprMobileServiceModule,
    decorators: [{
      type: Optional
    }, {
      type: SkipSelf
    }]
  }], null);
})();

/*
 * Public API Surface of upr-mobile-service
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BlockoutUrls, UprMobileService, UprMobileServiceModule, VenueUrls };
